import { plural } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import React from 'react'

interface DocumentCardResultCountLabelProps {
  displayCount: number
  hasActiveFilters: boolean
  pageEnd: number
  pageStart: number
  resultCount: number
  totalCount: number
}

export function DocumentCardResultCountLabel({
  displayCount,
  hasActiveFilters,
  pageEnd,
  pageStart,
  resultCount,
  totalCount,
}: DocumentCardResultCountLabelProps): React.ReactElement {
  const { t } = useLingui()
  const rangeStart = resultCount > 0 ? Math.max(pageStart, 0) + 1 : 0
  const rangeEnd = Math.max(pageEnd, 0)
  const totalCountLabel = totalCount.toLocaleString()

  return (
    <>
      {t`Showing ${rangeStart}-${rangeEnd} of ${plural(displayCount, {
        one: '# result',
        other: '# results',
      })}`}
      {hasActiveFilters && totalCount !== displayCount && (
        <> {t`(filtered from ${totalCountLabel})`}</>
      )}
    </>
  )
}
